import { CREDIT_DECISION_DEACTIVATION_REASONS } from '@/constants/company';
import { TypedDocumentNode, gql } from '@apollo/client';

export type GetLimitDeactivationReasonQueryType = {
  orders_companies_by_pk: {
    core_company: {
      latest_published_credit_decision: {
        deactivation_reason: CREDIT_DECISION_DEACTIVATION_REASONS | null;
      };
    };
  };
};
export const getLimitDeactivationReasonQuery = gql`
  query getLatestCreditDeactivationReason($companyId: bigint!) {
    orders_companies_by_pk(id: $companyId) {
      id
      core_company {
        id: uid
        latest_published_credit_decision {
          deactivation_reason
        }
      }
    }
  }
` as TypedDocumentNode<
  GetLimitDeactivationReasonQueryType,
  { companyId: number }
>;
